import {
  ApiClientError,
  GetProductsQuery,
  Paginated,
  Product,
} from '@raydiant/api-client-js';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';
import { QueryObserverOptions } from 'react-query';
import { useState } from 'react';

type Options = GetProductsQuery & {
  refetchInterval?: QueryObserverOptions['refetchInterval'];
  visibility?: string;
};

export default function useCatalogItems(catalogId: string, opts: Options) {
  const { refetchInterval: refetchIntervalOpt, ...apiOptions } = opts;
  const [refetchInterval, setRefetchInterval] = useState(refetchIntervalOpt);

  const query = useProtectedQuery<Paginated<Product>, ApiClientError>(
    keys.catalogItems(catalogId, opts),
    async () => {
      const response = await raydiant.getProducts(catalogId, apiOptions);
      const { visibility } = opts;

      if (
        (!response.data || response.data.length === 0) &&
        visibility === 'all'
      ) {
        throw new Error('No products found. refetching');
      }

      setRefetchInterval(false);
      return response;
    },
    {
      refetchInterval,
    },
  );

  return query;
}
